import NotFoundSection from '@/components/sections/notFound/NotFoundSection'
import { useData } from '@/hooks/useLocale'
import { useTitle } from '@/hooks/useTitle'

/** Any path without a page. */
export default function NotFoundPage() {
  const { NOT_FOUND } = useData()
  useTitle(NOT_FOUND.title)

  return <NotFoundSection />
}
